import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { getHost } from "../utils/utils";

const ADMIN_CLIENT_ID = "68fe273606016adb4b0c5904";
const getToken = () => localStorage.getItem("jwt");

export default function AdminRoute() {
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    fetch(`${getHost()}/api/clients`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const hasAccess = (data.clients || []).some(
          (c) => c._id === ADMIN_CLIENT_ID
        );
        setAuthorized(hasAccess);
      })
      .catch(() => setAuthorized(false));
  }, []);

  if (authorized === null) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-gradient-black">
        <Spinner animation="border" className="text-white" />
      </div>
    );
  }

  if (!authorized) return <Navigate to="/" replace />;

  return <Outlet />;
}
